package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

@Composable
fun ZapierForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "For me, understanding the road has always been more about building it, not merely driving. Challenging work motivates. It cannot be done without the right environment. Zapier seems to provide both.",
        "I decide deliberately about the next step in my career path. Cultural fit is the most important factor in choosing who to approach. I've put Zapier on my list from day one and I am glad a role I can apply to, and mean it, opened.",
        "There's a lot I find admirable about your approach. " +
                "The remote-since-day-one origins. " +
                "How you nurture your roots with the documentation. " +
                "That your writing is not a decoration. " +
                "You put great effort into making it understandable, actionable and accompanied by positive and negative examples. " +
                "The article on Zapier values is the best formulation on the topic I've found. " +
                "It shows, from experience, that dull statements can be mangled and distorted to serve an individual, not the team.",
        "And hey, we're very much aligned on the stance towards AI use in the workplace."
    )
}
